import React from 'react';
import { Link } from 'react-router-dom';
import { Trash2, Minus, Plus, ShoppingBag, ArrowRight, Home } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../lib/format';

const Cart = () => {
  const { cart, updateQty, removeFromCart, totalPrice } = useCart();

  return (
    <div className="bg-white min-h-screen">
      <div className="bg-neutral-50 border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 py-3 text-sm flex items-center gap-2 text-neutral-500">
          <Link to="/" className="hover:text-amber-600 flex items-center gap-1">
            <Home className="w-3.5 h-3.5" /> Acasă
          </Link>
          <span>/</span>
          <span className="text-neutral-900">Coș</span>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-10">
        <h1 className="text-3xl md:text-4xl font-serif font-bold text-neutral-900 mb-8">Coșul tău</h1>

        {cart.length === 0 ? (
          <div className="text-center py-20 bg-neutral-50 rounded-2xl border border-dashed border-neutral-300">
            <ShoppingBag className="w-16 h-16 text-neutral-300 mx-auto mb-4" />
            <p className="text-neutral-600">Coșul tău este gol</p>
            <Link to="/magazin" className="inline-block mt-5 px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white rounded-full text-sm font-medium">
              Mergi la magazin
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 bg-white border border-neutral-200 rounded-2xl overflow-hidden">
              <table className="w-full">
                <thead className="bg-neutral-50 text-xs uppercase tracking-wider text-neutral-500">
                  <tr>
                    <th className="text-left p-4">Produs</th>
                    <th className="text-center p-4 hidden md:table-cell">Preț</th>
                    <th className="text-center p-4">Cantitate</th>
                    <th className="text-right p-4">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {cart.map((item) => (
                    <tr key={item.id} className="border-t border-neutral-100">
                      <td className="p-4">
                        <div className="flex items-center gap-4">
                          <img src={item.image} alt={item.name} className="w-16 h-16 rounded-lg object-cover bg-neutral-50" />
                          <div>
                            <Link to={`/produs/${item.slug}`} className="font-medium text-neutral-900 hover:text-amber-700 line-clamp-2">
                              {item.name}
                            </Link>
                            <button onClick={() => removeFromCart(item.id)} className="mt-1 text-xs text-neutral-400 hover:text-red-500 inline-flex items-center gap-1">
                              <Trash2 className="w-3 h-3" /> Șterge
                            </button>
                          </div>
                        </div>
                      </td>
                      <td className="p-4 text-center hidden md:table-cell text-neutral-700">{formatPrice(item.price)}</td>
                      <td className="p-4">
                        <div className="flex items-center justify-center">
                          <div className="inline-flex items-center border border-neutral-300 rounded-full">
                            <button onClick={() => updateQty(item.id, item.qty - 1)} className="w-8 h-8 flex items-center justify-center hover:bg-neutral-50 rounded-l-full">
                              <Minus className="w-3 h-3" />
                            </button>
                            <span className="w-8 text-center text-sm font-medium">{item.qty}</span>
                            <button onClick={() => updateQty(item.id, item.qty + 1)} className="w-8 h-8 flex items-center justify-center hover:bg-neutral-50 rounded-r-full">
                              <Plus className="w-3 h-3" />
                            </button>
                          </div>
                        </div>
                      </td>
                      <td className="p-4 text-right font-semibold text-neutral-900">{formatPrice(item.price * item.qty)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <aside className="bg-white border border-neutral-200 rounded-2xl p-6 h-fit sticky top-32">
              <h3 className="font-serif font-bold text-xl text-neutral-900">Sumar comandă</h3>
              <dl className="mt-5 space-y-3 text-sm">
                <div className="flex justify-between"><dt className="text-neutral-500">Subtotal</dt><dd className="font-medium">{formatPrice(totalPrice)}</dd></div>
                <div className="flex justify-between"><dt className="text-neutral-500">Livrare</dt><dd className="font-medium">{totalPrice >= 500 ? 'Gratuit' : formatPrice(25)}</dd></div>
                <div className="border-t border-neutral-200 pt-3 flex justify-between text-base">
                  <dt className="font-semibold text-neutral-900">Total</dt>
                  <dd className="font-bold text-neutral-900 text-lg">{formatPrice(totalPrice + (totalPrice >= 500 ? 0 : 25))}</dd>
                </div>
              </dl>
              <Link to="/checkout" className="mt-6 flex items-center justify-center gap-2 w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold py-3 rounded-full transition-colors">
                Finalizează comanda <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/magazin" className="mt-3 block text-center text-sm text-neutral-500 hover:text-amber-600">
                Continuă cumpărăturile
              </Link>
            </aside>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cart;
